import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';

const AdminLayout = (props) => {
  // this is admin layout  component thet will be used in all admin pages
  //  it will take the children props and render it in the main section

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const user = localStorage.getItem('name');
  const role = localStorage.getItem('role');

  return (
    <div>
      <Header
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        Heading="Admin"
        Btn="42"
        P1="Dashboard"
        R1="/AdminHome"
        i1="bi bi-grid"
        Ac1={props.ac1}
        P2="Manage Subject"
        R2="/ListSubject"
        i2="bi bi-circle-fill"
        Ac2={props.ac2}
        // this is the master page dropdown menu
        P14="Subject Objectives"
        R14="/ObjectiveList"
        i14="bbi bi-circle-fill"
        Ac14={props.ac14}
        P15="Programs"
        R15="/ProgramList"
        i15="bi bi-circle-fill"
        Ac15={props.ac15}
        P16="Program Objective"
        R16="/ProgramObjectiveList"
        i16="bi bi-circle-fill"
        Ac16={props.ac16}
        P3="Manage Faculty"
        R3="/ListFaculty"
        i3="bi bi-person-fill-gear"
        Ac3={props.ac3}
        P4="Manage Exams"
        R4="/ListExam"
        i4="bi bi-journal-text"
        Ac4={props.ac4}
        P6="Student Details"
        R6="/StudentDasboard"
        i6="bi bi-passport"
        Ac6={props.ac6}
        P7="Internal Marks"
        R7="/InternalDasboard"
        i7="bi bi-graph-up-arrow"
        Ac7={props.ac7}
        P8="Manage Result "
        R8="/ResultDasboard"
        i8="bi bi-clipboard2-data"
        Ac8={props.ac8}
        P9="Reassessment"
        R9="/ReasseDasboard"
        i9="bi bi-bootstrap-reboot"
        Ac9={props.ac9}
        P10="Rejected Sheet"
        R10="/RejectedDasboard"
        i10="bi bi-clipboard2-x"
        Ac10={props.ac10}
        P11="Report"
        R11="/ReportDashbord"
        i11="bi bi-journal-richtext"
        Ac11={props.ac11}
        P12="Menual Result"
        R12="/menualmarkexam"
        i12="bi bi-tools"
        Ac12={props.ac12}
        P13="OMR Marks"
        R13="/omrmarkexam"
        i13="bi bi-file-text"
        Ac13={props.ac13}
        op="Settings"
        opr="/Setting"
        opi="bi bi-gear"
        op1="History"
        opr1="/AdminHistory"
        opi1="bi bi-clock-history"
        h1="/AdminHome"
        DR={props.dr}
        user={user}
        role={role}
      />
      <main className={` main ${sidebarOpen ? 'open' : 'close'}`}>
        <div className="main-herder">{props.children}</div>
        <Footer />
      </main>
    </div>
  );
};

export default AdminLayout;
